import { isFulfilled, isPending, isRejectedWithValue } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { formatErrorMessage } from '../utils';

// eslint-disable-next-line import/prefer-default-export
// Only mutations (create/update/delete) get a toast — background reads
// (list/detail queries, refetches on cache invalidation, etc.) used to hit
// this same code path and popped a "Please wait..." / "Done" toast on every
// single one of them, which made the whole app feel like it was constantly
// reloading even though nothing had actually failed.
const isMutation = (action) => action.meta?.arg?.type === 'mutation';

export const rtkQueryErrorLogger = () => (next) => (action) => {
  const TOAST_QUERY_ID = 'query-status';
  if (isMutation(action)) {
    if (isPending(action)) {
      toast('Please wait...', {
        isLoading: true,
        type: toast.TYPE.DEFAULT,
        toastId: TOAST_QUERY_ID,
      });
    } else if (isFulfilled(action)) {
      toast.update(TOAST_QUERY_ID, {
        render: 'Done',
        isLoading: false,
        type: toast.TYPE.SUCCESS,
        autoClose: 3000,
      });
      setTimeout(() => {
        toast.dismiss(TOAST_QUERY_ID);
      }, 3000);
    } else if (isRejectedWithValue(action)) {
      toast.update(TOAST_QUERY_ID, {
        render: formatErrorMessage(action.payload.data),
        isLoading: false,
        type: toast.TYPE.ERROR,
      });
      setTimeout(() => {
        toast.dismiss(TOAST_QUERY_ID);
      }, 1000);
    }
  } else if (isRejectedWithValue(action)) {
    toast.error(formatErrorMessage(action.payload.data));
  }

  return next(action);
};
